import { DragDropModule } from "@angular/cdk/drag-drop";
import { LayoutModule } from "@angular/cdk/layout";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatRippleModule } from "@angular/material/core";
import { MatMenuModule } from "@angular/material/menu";
import { RouterModule } from "@angular/router";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { InlineSVGModule } from "ng-inline-svg";
import { ColorPickerModule } from "ngx-color-picker";
import { OrganizationTypesManagerComponent } from "../organizations/settings/components/organization-types-manager/organization-types-manager.component";
import { AgGridTablesModule } from "./ag-grid/ag-grid.module";
import { GridHeaderComponent } from "./ag-grid/cell-renderers/grid-header/grid-header.component";
import { TotalGridRowsComponent } from "./ag-grid/cell-renderers/only-grid-components/total-grid-rows/total-grid-rows.component";
import { AccordionDisplayComponent } from "./components/accordion-display/accordion-display.component";
import { BasicContainerComponent } from "./components/basic-container/basic-container.component";
import { BreadcrumbsComponent } from "./components/breadcrumbs/breadcrumbs.component";
import { ColumnBoxComponent } from "./components/column-box/column-box.component";
import { DashboardPortalModule } from "./components/dashboard-portal/dashboard-portal.module";
import { InsightsAnomaliesGridModule } from "./components/dynamic-dashboard/components/insights-anomalies/anomalies-grids/insights-anomalies-grid.module";
import { FileUploadComponent } from "./components/file-upload/file-upload.component";
import { FlowStepDirective } from "./components/flow/directive/flow-step.directive";
import { FlowComponent } from "./components/flow/flow.component";
import { ForceDirectedGraphModule } from "./components/force-directed-graph/force-directed-graph.module";
import { InfoBarComponent } from "./components/info-bar/info-bar.component";
import { MapComponent } from "./components/map/map.component";
import { NavForDynamicComponent } from "./components/nav-for-dynamic/nav-for-dynamic.component";
import { PageSpinnerComponent } from "./components/page-spinner/page-spinner.component";
import { PeriodTimeSelectionComponent } from "./components/period-time-selection/period-time-selection.component";
import { ProgressBarComponent } from "./components/progress-bar/progress-bar.component";
import { SingleSyncStatusComponent } from "./components/single-entities/single-sync-status/single-sync-status.component";
import { SyncedEntityPropertiesComponent } from "./components/synced-entity-properties/synced-entity-properties.component";
import { MaterialModule } from "./material.module";
import { ActionKpiDialogComponent } from "./modals/action-kpi-dialog/action-kpi-dialog.component";
import { AddOrgTypeDialogComponent } from "./modals/add-org-type-dialog/add-org-type-dialog.component";
import { ConfirmationModalComponent } from "./modals/confirmation-modal/confirmation-modal.component";
import { NetopDialogModule } from "./modals/netop-dialog/netop-dialog.module";
import { SaveEditedPropertiesComponent } from "./modals/save-edited-properties/save-edited-properties.component";
import { SnackBarComponent } from "./modals/snack-bar/snack-bar.component";
import { SyncChangesModalComponent } from "./modals/sync-changes-modal/sync-changes-modal.component";
import { NgxSelectModule } from "./ngx-select/ngx-select.module";
import { TemplateRefDirective } from "./pipes/string-as-template-ref/template-ref.directive";
import { SharedComponentsModule } from "./shared-components.module";
import { SharedDirectivesModule } from "./shared-directives.module";
import { SharedPipesModule } from "./shared-pipes.module";
import { TooltipAsCellRendererComponent } from "./ag-grid/cell-renderers/tooltip-as-cell-renderer/tooltip-as-cell-renderer.component";
import { ActionsFiltersComponent } from "../features/anomalies/components/main-actions-dashboard/components/actions-filters/actions-filters.component";
import { ActionsListComponent } from "../features/anomalies/components/main-actions-dashboard/components/actions-list/actions-list.component";
import { NbEvaIconsModule } from "@nebular/eva-icons";
import { NbLayoutModule, NbActionsModule, NbMenuModule, NbContextMenuModule, NbCardModule, NbIconModule, NbSearchModule } from "@nebular/theme";
import { TimePickerComponent } from "src/ntx-app/components/time-picker/time-picker.component";
@NgModule({
  declarations: [
    ColumnBoxComponent,
    ConfirmationModalComponent,
    SnackBarComponent,
    MapComponent,
    BreadcrumbsComponent,
    PageSpinnerComponent,
    FlowComponent,
    FlowStepDirective,
    BasicContainerComponent,
    TotalGridRowsComponent,
    GridHeaderComponent,
    SaveEditedPropertiesComponent,
    SingleSyncStatusComponent,
    ActionKpiDialogComponent,
    FileUploadComponent,
    ProgressBarComponent,
    SyncChangesModalComponent,
    SyncedEntityPropertiesComponent,
    TemplateRefDirective,
    NavForDynamicComponent,
    AddOrgTypeDialogComponent,
    OrganizationTypesManagerComponent,
    AccordionDisplayComponent,
    InfoBarComponent,
    PeriodTimeSelectionComponent,
    ActionsListComponent,
    ActionsFiltersComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    AgGridTablesModule,
    MaterialModule,
    InlineSVGModule,
    RouterModule,
    DashboardPortalModule,
    LayoutModule,
    NgxSelectModule,
    NetopDialogModule,
    NgbTooltipModule,
    DragDropModule,
    MatMenuModule,
    ColorPickerModule,
    MatRippleModule,
    SharedComponentsModule,
    SharedPipesModule,
    SharedDirectivesModule,
    MatButtonModule,
    InsightsAnomaliesGridModule,
    NbEvaIconsModule,
    NbLayoutModule,
    NbActionsModule,
    NbMenuModule,
    NbContextMenuModule,
    NbCardModule,
    NbIconModule,
    NbSearchModule,
    TimePickerComponent,
  ],
  exports: [
    CommonModule,
    ForceDirectedGraphModule,
    NgbTooltipModule,
    InsightsAnomaliesGridModule,
    NetopDialogModule,
    DragDropModule,
    SharedComponentsModule,
    ColumnBoxComponent,
    MapComponent,
    TranslateModule,
    AgGridTablesModule,
    ReactiveFormsModule,
    MatMenuModule,
    FormsModule,
    MaterialModule,
    MatRippleModule,
    SharedPipesModule,
    SharedDirectivesModule,
    PeriodTimeSelectionComponent,
    InlineSVGModule,
    ColorPickerModule,
    TooltipAsCellRendererComponent,
    BreadcrumbsComponent,
    ActionKpiDialogComponent,
    SyncChangesModalComponent,
    SaveEditedPropertiesComponent,
    SingleSyncStatusComponent,
    ConfirmationModalComponent,
    SnackBarComponent,
    InfoBarComponent,
    PageSpinnerComponent,
    FlowComponent,
    FlowStepDirective,
    LayoutModule,
    TemplateRefDirective,
    NgxSelectModule,
    BasicContainerComponent,
    TotalGridRowsComponent,
    TotalGridRowsComponent,
    GridHeaderComponent,
    FileUploadComponent,
    ProgressBarComponent,
    NavForDynamicComponent,
    OrganizationTypesManagerComponent,
    AccordionDisplayComponent,
    ActionsListComponent,
    ActionsFiltersComponent
  ]
})
export class SharedModule {
}
